class Filter {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement() {
    return this.element;
  }
  
  getHandle() {
    return this.element.dataset.url;
  }

  getSelectContainer() {
    let element = this.getElement();
    return element.querySelectorAll(".js-selectContainer");
  }

  getSelect() {
    let element = this.getElement();
    return element.querySelectorAll('.js-select');
  }

  getCollectionAll() {
    let element = this.getElement();
    return element.dataset.all;
  }

  getOptions() {
    let element = this.getElement();
    return element.querySelectorAll('.js-option');
  }

  getRemove() {
    let element = this.getElement();
    return element.querySelectorAll('.js-remove');
  }

  getProducts() {
    let element = this.getElement();
    return element.closest('.js-slider').querySelectorAll('.js-productCard');
  }

  getTitle() {
    let element = this.getElement();
    return element.closest('.js-slider').querySelectorAll('.js-title');
  }

  getSelectedOptions() {
    let element = this.getElement();
    return element.querySelector('.js-selectedOptions');
  }

  getCurrentOptions() {
    let element = this.getElement();
    return element.querySelectorAll('.js-selectOption');
  }

  getClear(){
    let element = this.getElement();
    return element.querySelector('.js-clear');
  }

  getContainer() {
    let element = this.getElement();
    return element.closest('.js-collection');
  }

  removeOption() {
    let removeEl = this.getRemove();
    for(let remove of removeEl) {
      remove.addEventListener('click', () => {
        window.location.href = remove.querySelector('a').href;
      })
    }
  }

  changeUrl() {
    let selectEl = this.getSelect();
    let handleEl = this.getHandle();
    let queryEl = '';
    let querySortEl = '';
    let count = 0;

    for(let select of selectEl) {
      let selectedTag = select.dataset.selectedTag;
      if(selectedTag.length !== 0 || selectedTag !== ''){
        count++;
        if(count > 1) {
          if(selectedTag.includes('sort_by')){
            querySortEl = '?'+selectedTag;
          }
          else{
            queryEl += '+'+selectedTag;
          }
        }else{
          if (selectedTag.includes('sort_by')) {
            queryEl = '?'+selectedTag
          }
          else{
            queryEl = '/'+selectedTag;
          }
        }
      }
    }

    window.location.href=handleEl+queryEl+querySortEl;
  }

  fetchFilters() {
    let selectEl = this.getSelect();
    let handleEl = this.getHandle();
    let queryEl = '';
    let count = 0;

    for(let select of selectEl) {
      if(select.dataset.selectedTag !== undefined){
        count++;
        if(count > 1) {
          queryEl += '+'+select.dataset.selectedTag;
        }else{
          queryEl = '/'+select.dataset.selectedTag;
        }
      }
    }

    fetch(handleEl+queryEl)
      .then(response => response.text())
      .then(data =>{
        let parser = new DOMParser();
        let doc = parser.parseFromString(data, "text/html");
        let filteredProducts = doc.querySelectorAll('.js-productCard');
        document.querySelector('.js-collectionProducts').innerHTML = '';
        for(let product of filteredProducts) {
          document.querySelector('.js-collectionProducts').appendChild(product);
        }
        document.querySelector('.js-selectedOptions').innerHTML = doc.querySelector('.js-selectedOptions').innerHTML;
      })
  }

  showDropdown() {
    let selectEl = this.getSelectContainer();

    for (let select of selectEl) {
      select.addEventListener('click', (event) => {
        try{
          if(select.closest('.js-selects').querySelector('.active') !== event.target.parentNode){
            select.closest('.js-selects').querySelector('.active').classList.remove('active');
          }
        }catch{}

        select.closest('.js-select').classList.toggle('active');
      })
    }
  }

  addContainerActive() {
    let containerEl = this.getContainer();
    containerEl.classList.add('active');
  }

  removeContainerActive() {
    let containerEl = this.getContainer();
    containerEl.classList.remove('active');
  }

  optionSelect() {
    let optionEl = this.getOptions();
    let collectionAllEl = this.getCollectionAll();

    for(let option of optionEl) {
      option.addEventListener('click', () => {
        this.addContainerActive();
        this.closeDropdown();
        let selectedTag = option.dataset.tag;

        let arrayTags = option.closest('.js-selects').querySelectorAll('.js-selectOption');
        option.closest('.js-select').dataset.selectedTag = selectedTag;
        option.closest('.js-select').querySelector('.js-selected').innerHTML = option.innerHTML;
        // this.fetchFilters();
        collectionAllEl === 'true' ? this.optionSelectAll(arrayTags, 1) : this.changeUrl();
      })
    }
  }

  optionSelectNonClick() {
    let optionEl = this.getCurrentOptions();

    for(let option of optionEl) {
      let arrayTags = option.closest('.js-selects').querySelectorAll('.js-selectOption');
      this.optionSelectAll(arrayTags, 0)
    }
  }

  hideSelectedOptions() {
    let selectedOptions = this.getSelectedOptions();

    selectedOptions.classList.remove('active');
  }

  hideTitle() {
    let titleEl = this.getTitle();

    for(let title of titleEl) {
      title.classList.add('hide');
    }
  }

  showTitle() {
    let titleEl = this.getTitle();

    this.hideSelectedOptions();

    for(let title of titleEl) {
      title.classList.remove('hide');
    }
  }

  setClear() {
    let clearEl = this.getClear();
    let selectedOptions = this.getCurrentOptions();

    clearEl.addEventListener('click', () => {
      for(let selected of selectedOptions) {
        selected.dataset.selectedTag = '';
        selected.querySelector('.js-selected').innerHTML = 'All';
        this.optionSelectNonClick();
      }
    })
  }

  removeFilter(tagEl) {
    let removeEl = this.getRemove();
    let tagOptionsEl = tagEl;

    for(let remove of removeEl) {
      remove.addEventListener('click', () => {
        remove.closest('.Collection__filter__selected--item').remove();

        Array.from(tagOptionsEl).map((tag) => {
          if(tag.dataset.selectedTag === remove.dataset.tag){
            tag.dataset.selectedTag = '';
            tag.querySelector('.js-selected').innerHTML = 'All';
          }
        })
        this.optionSelectNonClick();
      })
    }
  }

  showSelectedTags(currentArray, tagEl) {
    let selectedTagDiv = this.getSelectedOptions();
    let liClear = document.createElement('li');

    selectedTagDiv.classList.add('active');

    selectedTagDiv.innerHTML = '';
    liClear.classList.add('Collection__filter__clear');
    liClear.innerHTML = `<div class="p-mono white js-clear">Clear All</div>`;

    currentArray.map((arr) => {
      if(arr != '' ){
        let li = document.createElement("li");

        li.classList.add('Collection__filter__selected--item');
        li.innerHTML = 
          `
            <button class="Collection__filter__selected-option js-remove" data-tag="${arr}">
              <span class="p-mono white">${arr.split('_')[1]}</span>
              <span><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 4.47377L0.526306 0L0 0.526316L4.47369 5.00009L0.000181808 9.47368L0.526488 10L5 5.52641L9.47351 10L9.99982 9.47368L5.52631 5.00009L10 0.526316L9.47369 0L5 4.47377Z" fill="white"></path></svg></span>
            </button>
            `
        selectedTagDiv.prepend(li);
      }
    })
    this.removeFilter(tagEl);
    selectedTagDiv.append(liClear);
    this.setClear();
  }

  optionSelectAll(tagEl, enable) {
    let productEl = this.getProducts();
    let currentArray = [];

    for(let tag of tagEl) {
      if(tag.dataset.selectedTag !== ''){
        currentArray.push(tag.dataset.selectedTag);
      }
    }  

    let currentArrayLength = currentArray.every((current) => {
      return current === '' ?  true :  false;
    })


    enable === 1 
    ? this.showSelectedTags(currentArray, tagEl)
    : null;

    if(currentArrayLength === false) {
      Array.from(productEl).map((prod) => {
        if((currentArray.every(array => prod.dataset.tags.includes(array)) === true)){
          prod.classList.remove('hide');
        }
        else{
          prod.classList.add('hide');
        }
      })
    }else{
      this.removeContainerActive();
      Array.from(productEl).map((prod) => {
        prod.classList.remove('hide');
      })
    }

    
    currentArrayLength === false
      ? this.hideTitle()
      : this.showTitle();
  }

  collectionAllFiltering() {
    let collectionAllEl = this.getCollectionAll();

    if (collectionAllEl === 'true') {

    }
  }

  closeDropdown() {
    let selectEl = this.getSelect();

    for(let select of selectEl) {
      select.classList.remove('active');
    }
  }

  setEventHandlers() {
    this.showDropdown();
    this.optionSelect();
    this.removeOption();
    this.collectionAllFiltering();
  }

  init() {
    this.setEventHandlers();
  }
}

const FilterInit = {
  init() {
    const $el = document.querySelector(".js-filter");
    if ($el) {
      new Filter($el);
    }
  },
};


export default FilterInit;